import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  blankState: {
    padding: "12px 10px",
    borderRadius: 0,
    borderLeft: 0,
    borderRight: 0,
    borderBottom: 0,
  },
  blankStatePresentationMode: {
    backgroundColor: "#2C2F3C",
    border: "1px solid #333544",
  },
  textPresentationMode: {
    color: theme.palette.white,
    opacity: 0.7,
  },
}));
